import { render } from "./ShowFootnotesSwitch.vue?vue&type=template&id=7f78d45d&scoped=true"
import script from "./ShowFootnotesSwitch.vue?vue&type=script&lang=js"
export * from "./ShowFootnotesSwitch.vue?vue&type=script&lang=js"

import "./ShowFootnotesSwitch.vue?vue&type=style&index=0&id=7f78d45d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f78d45d"]])

export default __exports__